<template>
  <div :class="['lr-modal', {'hide': !insurance.showCreate}]">
    <div class="lr-box">
      <div class="d-flex justify-space-between align-start">
        <div class="ins-field">
          <label>Start Date</label>
          <datepicker :format="calendarFormat" v-model="start"
            :class="['datepicker inline', {'has-error':!!validation.start}]"
          ></datepicker>
          <span class="error-msg" v-if="validation.start">{{ validation.start }}</span>
        </div>
        <div class="ins-field">
          <label>END Date</label>
          <datepicker :format="calendarFormat" v-model="end"
            :class="['datepicker inline', {'has-error':!!validation.end}]"
          ></datepicker>
          <span class="error-msg" v-if="validation.end">{{ validation.end }}</span>
        </div>
      </div>
      <div class="ins-field">
        <label>Miles per day</label>
        <input type="number" v-model="miles" min="0"/>
      </div>
      <div class="ins-field">
        <label>Whitelist</label>
        <input type="text" v-model="whitelist" placeholder="e.g. 12345, 67"/>
      </div>
      <a class="button cta success block" @click="create">Create</a>
      <a class="button cta block secondary" @click="cancel">Cancel</a>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'

export default {
  name: 'insurance-create-modal',
  components: { datepicker },
  data () {
    return {
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      miles: 0,
      whitelist: ''
    }
  },
  computed: {
    insurance () { return this.$store.state.insurance },
  },
  methods: {
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    create () {
      let self = this

      let start = moment(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0)
      let end = moment(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59).set('second', 59)
      let hasError = false
      self.validation = { start: '', end: '' }
      if (!self.start) {
        hasError = true
        self.validation.start = 'this field is required.'
      }
      if (!self.end) {
        hasError = true
        self.validation.end = 'this field is required.'
      }
      if (self.start && self.end && end.diff(start, 'days') < 0) {
        hasError = true
        self.validation.start = 'Cannot be greater than end date.'
      }

      if (hasError) return
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post('/insurance/create', {
        token: self.$store.state.session.sessionToken,
        startUTC: start.format('X'),
        endUTC: end.format('X'),
        milesPerDay: self.miles,
        whitelist: self.whitelist
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: `Report Created Successfully!<br/>Report ID: <b>${r.id}</b>`
        })
        self.resetFields()
        self.$emit('refreshList')
        self.$store.commit('insurance/setListData', {showCreate: false})
      }, '2.0')
    },
    resetFields () {
      this.start = ''
      this.end = ''
      this.miles = 0
      this.whitelist = ''
    },
    cancel () {
      this.$store.commit('insurance/setListData', {showCreate: false})
    }
  },
  watch: {
    show (x) {
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  width: 460px;
  line-height: 1;
}

.ins-field{
  margin-bottom: 20px;
  text-align: left;

  label{
    letter-spacing: .4px;
    font-size: 14px;
    color: #777;
    line-height: 1;
    text-transform: uppercase;
  }
}
.error-msg{
  line-height: 1;
  display: block;
  font-size: 14px;
  color: #e34545;
  margin-top: 3px;
}
input{
  margin: 5px 0 0;
}

.button.success{
  margin-top: 20px;
}
.button.secondary{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/CreateModal.vue